let refreshTimeout = null;
export default function RefreshAds() {
  if (refreshTimeout) clearTimeout(refreshTimeout);
  refreshTimeout = setTimeout(() => {
    try {
      // Find all AdSense units that haven't been initialized yet and aren't currently being initialized by us
      const uninitializedAds = document.querySelectorAll('ins.adsbygoogle:not([data-adsbygoogle-status]):not([data-nagusi-loading])');

      // Call push() for each uninitialized unit
      for (let i = 0; i < uninitializedAds.length; i++) {
        const ad = uninitializedAds[i];

        // Mark as loading so we don't try to initialize it again before AdSense sets its own status attribute
        ad.setAttribute('data-nagusi-loading', 'true');

        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.warn('[nagusi/ads] Failed to refresh ads', e);
    }
  }, 100);
}